import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Grid, TextField, Typography } from '@material-ui/core';
import * as Yup from 'yup';
import { Formik } from 'formik';
import ClaimFormFooter from 'src/components/ClaimFormFooter';
import RequiredFieldsFormLabel from 'src/components/RequiredFieldsFormLabel';
import ClaimHeader from './claim-header';
import MuiPhoneNumber from 'material-ui-phone-number';
import { phoneNumberIsValid, cleanPhoneNumber } from 'src/utils/phone';
import useClaim from 'src/hooks/useClaimContext';


function ContactVerification({ claimContactInfo, dealerInfo, orderInfo, goBack, onSubmitSuccess }) {

  const { t } = useTranslation();
  const { formState, updateFormState } = useClaim();
  const {
    email = claimContactInfo.email,
    firstName = claimContactInfo.email,
    lastName = claimContactInfo.email,
    phoneNumber = claimContactInfo.email
  } = formState;

  //const { email, firstName, lastName, phoneNumber } = claimContact;
  return (
    <Formik
      initialValues={{ email, firstName, lastName, phoneNumber }}
      validationSchema={Yup.object({
        email: Yup.string()
          .email()
          .required(t('emailIsRequired'))
          .typeError(t('pleaseEnterValidEmail')),
        phoneNumber: Yup.string()
          .test(
            'Phone number test',
            t('phoneNumberMustBeValid'),
            value => phoneNumberIsValid(value)
          )
          .typeError(t('pleaseEnterValidPhoneNumber')),
      })}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          setSubmitting(true);
          updateFormState({ email: values.email });
          updateFormState({ firstName: values.firstName });
          updateFormState({ lastName: values.lastName });
          updateFormState({ phoneNumber: values.phoneNumber });
          onSubmitSuccess(values);
        } catch (error) {
          console.log(error);
          setSubmitting(false);
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting
      }) => (
        <Box>
          <ClaimHeader
            dealerInfo={dealerInfo}
            orderInfo={orderInfo}
          />
          <Grid container style={{ paddingLeft: 16 }}>
            <Grid item xs={12}>
              <>
                <Typography variant="h3" color="textPrimary">
                  {t('verifyContact')}
                </Typography>
                <Box ml={1} />
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                >
                  {t('pleaseEnterEmailForUpdates')}
                </Typography>
              </>
            </Grid>
          </Grid>
          <form onSubmit={handleSubmit}>
            <Box component="main" p={4}>
              <RequiredFieldsFormLabel />
              <Box my={3}>
                <Grid container spacing={2}>
                  <Grid item xs={8} md={4}>
                    <TextField
                      required
                      fullWidth
                      autoFormat
                      error={Boolean(touched.email && errors.email)}
                      helperText={touched.email && errors.email}
                      label={t('email')}
                      margin="none"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.email}
                      variant="outlined"
                      inputProps={{ name: 'email' }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <TextField
                      required
                      fullWidth
                      error={Boolean(touched.firstName && errors.firstName)}
                      helperText={touched.firstName && errors.firstName}
                      label={t('firstName')}
                      margin="none"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.firstName}
                      variant="outlined"
                      inputProps={{ name: 'firstName' }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <TextField
                      required
                      fullWidth
                      error={Boolean(touched.lastName && errors.lastName)}
                      helperText={touched.lastName && errors.lastName}
                      label={t('lastName')}
                      margin="none"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.lastName}
                      variant="outlined"
                      inputProps={{ name: 'lastName' }}
                    />
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <MuiPhoneNumber
                      isValid={() => true} // override the unnecessary additional validation MuiPhoneNumber provides
                      fullWidth
                      autoFormat
                      disableCountryCode
                      disableDropdown
                      onlyCountries={['us']}
                      defaultCountry="us"
                      error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                      helperText={touched.phoneNumber && errors.phoneNumber}
                      label={t('phoneNumber')}
                      margin="none"
                      onBlur={handleBlur}
                      onChange={phoneNumber => {
                        const value = cleanPhoneNumber(phoneNumber);
                        handleChange({ target: { name: 'phoneNumber', value } });
                      }}
                      value={values.phoneNumber}
                      variant="outlined"
                      inputProps={{ name: 'phoneNumber' }}
                    />
                  </Grid>
                </Grid>
              </Box>
              <ClaimFormFooter
                hideGoBack={true}
                nextButton
                goBack={goBack}
                isFormSubmitting={isSubmitting}
              />
            </Box>
          </form>
        </Box>
      )}

    </Formik>

  );
}

ContactVerification.propTypes = {
  claimContactInfo: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  onSubmitContactInfo: PropTypes.func,
  goBack: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  dealerInfo: PropTypes.object,
  orderInfo: PropTypes.object
};

export default ContactVerification;
